<template>
  <!-- <div class="bg-top pt-0 pl-5 pr-0 pb-10"> -->
    
    <div>
        <div class="w-100">
            <b-carousel
                id="carousel-2"
                v-model="slide"
                :interval="5000"
                indicators
                :no-touch="false"
                >
                <b-carousel-slide
                    >
                    <div class="title_header"><span>VAY</span> AN TOÀN,<br>
                        <!-- YÊN TÂM VỚI<br> -->
                        ĐỐI TÁC <span>UY TÍN</span></div>
                    <div class="title_content">
                        <span>Vclick</span> là <span>Sàn tín dụng </span>kết nối người cần vay với các ngân hàng và tổ chức tín dụng uy tín
                    </div>
                    <!-- <div class="font-bold te color-bold-vmain text-border text-xl">lên đến 80 triệu</div> -->

                </b-carousel-slide>

                <!-- <b-carousel-slide
                    >
                    <div class="font-bold color-bold-vmain text-border text-xl">Vay an toàn, an tâm với đối tác uy tín</div>
                </b-carousel-slide>

                <b-carousel-slide
                    >
                    <div class="font-bold color-bold-vmain text-border text-xl">Vay đơn giản, quy trình online 100%</div>
                </b-carousel-slide> -->
            </b-carousel>
        </div>
        <!-- <div class="inline-block">
            <div @click="slide = i-1" :class="{ activeSlide: slide == i - 1 ? true : false }" class="inline-block mr-1" style="width: 6px; height: 6px; border-radius: 2px; background-color: #f1c4c4;transition: opacity .6s ease" v-for="i in 3" :key="i"></div>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            slide: 0
        }
    },
}
</script>

<style>
.activeSlide{
    background-color: white !important;
}

/* .carousel-indicators li {
    background-color: #fff;
    width: 6px;
    border-radius: 3px;
    height: 6px;
    border-top: none;
    border-bottom: none;
}
.carousel-indicators li {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: .5;
    transition: opacity .6s ease;
} */
</style>